module.exports = __webpack_public_path__ + "static/media/28.9c848902.jpg";